

const template: any = {
};

export default template;
